import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/help/roles")({
	component: Roles,
});

export function Roles() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<p className="text-[10px] font-bold uppercase tracking-[0.1em]" style={{ color: "#6B3FF2", fontFamily: "inherit" }}>Access Control</p>
				<h1
					className="text-4xl font-semibold tracking-tight"
					style={{ color: "var(--km-on-surface)", fontFamily: "'Geist', -apple-system, sans-serif" }}
				>
					Roles and permissions
				</h1>
				<p className="text-sm" style={{ color: "var(--km-on-surface-muted)" }}>
					What each workspace role can do.
				</p>
			</div>

			<div className="space-y-4 text-sm leading-relaxed" style={{ color: "var(--km-on-surface-muted)" }}>
				<div className="space-y-2">
					{[
						{ role: "Owner", desc: "Full access. Can manage workspace settings, billing, connections, and members. Can delete the workspace.", color: "#6B3FF2" },
						{ role: "Member", desc: "Can create, edit, schedule, and delete posts. Cannot change workspace settings or manage billing.", color: "#2b9a66" },
					].map(({ role, desc, color }) => (
						<div key={role} className="flex items-start gap-3 px-4 py-3" style={{ background: "var(--km-surface-low)", border: "1px solid rgba(255,255,255,0.08)", borderLeft: `3px solid ${color}` }}>
							<span className="text-xs font-bold mt-0.5 shrink-0 px-2 py-0.5" style={{ background: `${color}18`, border: `1px solid ${color}40`, color, fontFamily: "'Geist Mono', 'JetBrains Mono', monospace" }}>{role.toUpperCase()}</span>
							<p>{desc}</p>
						</div>
					))}
				</div>
				<p>
					The workspace creator is automatically an Owner. You need at least
					one Owner per workspace.
				</p>

				<h2
					className="text-base font-semibold pt-2"
					style={{ color: "var(--km-on-surface)", fontFamily: "'Geist', -apple-system, sans-serif" }}
				>
					Managing roles
				</h2>
				<p>
					Owners can change a member&apos;s role or remove them from the workspace
					at any time from the <strong style={{ color: "var(--km-on-surface)" }}>Members</strong> page.
				</p>
			</div>

			<div
				className="flex items-center justify-between text-sm pt-4"
				style={{ borderTop: "1px solid rgba(255,255,255,0.08)" }}
			>
				<Link
					to="/help/inviting-members"
					className="flex items-center gap-1.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0072f5]/60"
					style={{ color: "var(--km-on-surface-muted)", textDecoration: "none" }}
					onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = "var(--km-on-surface)"; (e.currentTarget as HTMLElement).style.textDecoration = "underline dotted"; }}
					onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = "var(--km-on-surface-muted)"; (e.currentTarget as HTMLElement).style.textDecoration = "none"; }}
					onFocus={e => { (e.currentTarget as HTMLElement).style.color = "var(--km-on-surface)"; (e.currentTarget as HTMLElement).style.textDecoration = "underline dotted"; }}
					onBlur={e => { (e.currentTarget as HTMLElement).style.color = "var(--km-on-surface-muted)"; (e.currentTarget as HTMLElement).style.textDecoration = "none"; }}
				>
					<span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "16px" }}>arrow_back</span>
					Inviting members
				</Link>
				<Link
					to="/help/mcp"
					className="flex items-center gap-1.5 transition-colors font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0072f5]/60"
					style={{ color: "#6B3FF2", textDecoration: "none" }}
					onMouseEnter={e => { (e.currentTarget as HTMLElement).style.textDecoration = "underline dotted"; }}
					onMouseLeave={e => { (e.currentTarget as HTMLElement).style.textDecoration = "none"; }}
					onFocus={e => { (e.currentTarget as HTMLElement).style.textDecoration = "underline dotted"; }}
					onBlur={e => { (e.currentTarget as HTMLElement).style.textDecoration = "none"; }}
				>
					MCP overview
					<span className="material-symbols-outlined" aria-hidden="true" style={{ fontSize: "16px" }}>arrow_forward</span>
				</Link>
			</div>
		</article>
	);
}
